import { createSlice } from '@reduxjs/toolkit';
import { getSignedUrl, s3FileUpload } from './actions';

const initialState = {
  isUploading: false,
  uploadedFile: null,
  uploadedFiles: [],
  uploadError: null,
  isGettingSignedUrl: false,
  signedUrl: '',
  signedUrlError: null,
};

const s3Slice = createSlice({
  name: 's3',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(s3FileUpload.pending, (state) => {
        state.isUploading = true;
        state.uploadError = null;
      })
      .addCase(s3FileUpload.fulfilled, (state, action) => {
        state.isUploading = false;
        state.uploadedFile = action.payload;
        state.uploadedFiles.push(action.payload);
      })
      .addCase(s3FileUpload.rejected, (state, action) => {
        if (action.meta.aborted) return;
        state.isUploading = false;
        state.uploadError = action.payload || 'Error uploading file';
      })
      .addCase(getSignedUrl.pending, (state) => {
        state.isGettingSignedUrl = true;
        state.signedUrl = '';
        state.signedUrlError = null;
      })
      .addCase(getSignedUrl.fulfilled, (state, action) => {
        state.isGettingSignedUrl = false;
        state.signedUrl = action.payload;
      })
      .addCase(getSignedUrl.rejected, (state, action) => {
        if (action.meta.aborted) return;
        state.isGettingSignedUrl = false;
        state.signedUrl = '';
        state.signedUrlError = action.payload || 'Error getting file signedUrl';
      });
  },
});

export default s3Slice.reducer;
